import { forwardRef, TextareaHTMLAttributes } from 'react';
import cns from 'classnames';
import S from './Textarea.module.scss';

/**
 * @deprecated
 *
 * ### ⚠️ 사용 중단 예정.
 *
 * 신규 import 금지. 기존 7곳이 순차 이전 중이며, 새 import를 추가하는 순간
 * `git blame`은 그 책임을 단독으로 당신에게 할당합니다. 다음 스프린트의
 * 마이그레이션 PR에 자기 이름을 섞어넣고 싶지 않다면 `@zep-us/zus`를 쓰세요.
 *
 * ```tsx
 * // ❌
 * import { Textarea } from '@zep/ui';
 *
 * // ✅
 * import { TextArea } from '@zep-us/zus';
 * <TextArea.Root value={v}>
 *   <TextArea.Input value={v} onChange={h} />
 * </TextArea.Root>
 * ```
 *
 * 정책: 신규 추가 ❌ / 기존 파일 수정 시 같은 PR에서 ZUS로 이전 / 긴급 픽스만 TODO와 함께 허용.
 *
 * @see PR #2365
 */
export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>((props, ref) => {
  const {
    size = 'md',
    error,
    isFullWidth,
    className,
    ...rest
  } = props;
  return <textarea ref={ref} {...rest} className={cns(S.textarea, S[`size_${size}`], {
    [S.error]: error,
    [S.fullWidth]: isFullWidth,
    [S.disabled]: rest.disabled,
    [S.read_only]: rest.readOnly
  }, className)} />;
});
type TextareaProps = TextareaHTMLAttributes<HTMLTextAreaElement> & {
  size?: 'sm' | 'md';
  isFullWidth?: boolean;
  error?: boolean;
  disabled?: boolean;
  readOnly?: boolean;
};